import { StyleSheet, css } from "aphrodite"
import logo from '../assets/img/sangini_black.png'
import NavAction from "./navaction.component"
import NavProfileView from "./navprofileview.component"

import { createContext } from "react"
import { Link } from "react-router-dom"
import { BreadCrumb } from "./breadCrumb.component"
import commonCss, { compactNavView, mobileView } from "../commonCss/commonCss"
import { backgroundColor, greyColor, softBlack } from "../theme"
import { useNavbarHook } from "../hooks/useNavbarHook"
import GoldRateDisplay from "./goldRateDisplay"
import globalCSS from '../commonCss/commonCss'

interface NavbarProps extends React.HTMLAttributes<HTMLElement>{
    icon?: string,
    defaultAction: string
}
export const NavContext = createContext({} as any);

const navMenuId = "navbarMenu";
const navbarHeight = "90px";

export default function Navbar({icon, defaultAction, children}: NavbarProps) {
    const {isBreadCrumbOpened, handleNavAction, handleBreadCrumbToggle} = useNavbarHook();

    return <NavContext.Provider value={{handleNavAction}}>
        <nav className = {css(styles.navMain)} onMouseLeave={()=>handleBreadCrumbToggle(false)}>
            <div className={navBreadCrumbAndLogoContainer}>
                <Link to="/BuyJewelleries" className={css(commonCss.marginLR15px, styles.logoLink)} onClick={()=>handleNavAction()}>
                    <img src={icon || logo} alt="logo" className={css(styles.navLogoImg)} />
                </Link>
                <BreadCrumb isOpen={isBreadCrumbOpened} menuId={navMenuId} onClick={() => handleBreadCrumbToggle()} />
            </div>

            {/* Below the compact navbar width the links become a dropdown that the menu toggle opens. */}
            <div id={navMenuId} className={css(styles.actionItems, isBreadCrumbOpened && styles.actionItemsOpen)}>
                {children}
            </div>
            {isBreadCrumbOpened && (
                <div className={css(styles.menuBackdrop)} onClick={() => handleBreadCrumbToggle(false)} />
            )}

            <div className={css(globalCSS.flexRow, globalCSS.alignItemsCenter, globalCSS.justifyFlexEnd, globalCSS.width100P, styles.paddingRight10Px)}>
                <GoldRateDisplay/>
                <NavProfileView/>
            </div>

        </nav>
    </NavContext.Provider>
};
Navbar.Actions = NavAction;

const styles = StyleSheet.create({
    marginRight10P: {
        marginRight: '10%',
        [mobileView]: {
            marginRight: '10px'
        }
    },
    paddingRight10Px: {
        paddingRight: '10px',
        [mobileView]: {
            paddingRightRight: '10px'
        }
    },
    navMain: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        height: navbarHeight,
        boxSizing: 'border-box',
        boxShadow: `0px 1px 10px ${greyColor}`,
        position: "sticky",
        background: backgroundColor,
        top: "0px",
        zIndex: 100,
    },
    logoLink: {
        [mobileView]: {
            margin: '0 8px',
        },
    },
    navLogoImg: {
        height: '70px',
        minWxidth: '61px',
        [mobileView]: {
            height: '55px'

        }
    },

    actionItems: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [compactNavView]: {
            display: 'none',
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1,
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: '0.5rem 0',
            maxHeight: `calc(100vh - ${navbarHeight})`,
            overflowY: 'auto',
            background: backgroundColor,
            boxShadow: `0px 6px 12px ${greyColor}`,
        },
    },

    actionItemsOpen: {
        [compactNavView]: {
            display: 'flex',
        },
    },

    menuBackdrop: {
        display: 'none',
        [compactNavView]: {
            display: 'block',
            position: 'fixed',
            top: navbarHeight,
            left: 0,
            right: 0,
            bottom: 0,
            background: softBlack,
            opacity: 0.25,
        },
    },

    navMarginLeft: {
        marginLeft: "8%",
        [mobileView]: {
            marginLeft: "10px",
        }
    },
});

const navBreadCrumbAndLogoContainer = css(
    commonCss.flexRow,
    styles.navMarginLeft,
    commonCss.justifyCenter,
    commonCss.alignItemsCenter,
)
